import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaEnvelope, FaLock, FaEye, FaEyeSlash, FaHome } from 'react-icons/fa';
import './admin.css';
import { api } from '../lib/api';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.login(form.email, form.password);
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="admin-login-page">

      <Link to="/" className="admin-login-home" aria-label="Back to Patissora homepage">
        <FaHome /> Back to Site
      </Link>

      <div className="admin-login-split">

        {/* Left — branding panel */}
        <div className="admin-login-brand">
          <div className="admin-login-brand-overlay" />

        </div>

        {/* Right — form panel */}
        <div className="admin-login-form-panel">
          <div className="admin-login-card">
            <span className="admin-login-mark">P</span>

            <div className="admin-login-brandline">
              <h2>PATISSORA</h2>
              <p>Cake &amp; Custom House</p>
            </div>

            <h1 className="admin-login-title">Sign In</h1>

            <p className="admin-login-sub">Accounts are created by an administrator.</p>

            <form onSubmit={handleSubmit}>
              <div className="admin-form-group">
                <label>Email</label>
                <div className="admin-input-icon-wrap">
                  <FaEnvelope className="admin-input-icon" />
                  <input
                    type="email"
                    placeholder="Enter email"
                    required
                    value={form.email}
                    onChange={e => setForm({ ...form, email: e.target.value })}
                  />
                </div>
              </div>

              <div className="admin-form-group">
                <label>Password</label>
                <div className="admin-input-icon-wrap">
                  <FaLock className="admin-input-icon" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter password"
                    required
                    value={form.password}
                    onChange={e => setForm({ ...form, password: e.target.value })}
                  />
                  <button
                    type="button"
                    className="admin-input-eye"
                    onClick={() => setShowPassword(s => !s)}
                    aria-label="Toggle password visibility"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {error && <p className="admin-error">{error}</p>}

              <button type="submit" className="admin-btn admin-btn-primary admin-login-btn" disabled={loading}>
                {loading ? 'Signing in…' : 'Sign In'}
              </button>
            </form>

            <p className="admin-login-footer">
              Trouble signing in? Contact your system administrator.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}